import { onUnmounted } from 'vue';

export const keyboardEventTypes = {
    keyup: 'keyup',
    keydown: 'keydown',
    keypress: 'keypress',
};

// Registers keyboard shortcuts from a map of `KeyboardEvent.key` -> handler.
// Returns start/stop so callers can tie listening to their own lifecycle (e.g. modal visibility).
export function useKeyboardShortcuts(keyMap, { event = keyboardEventTypes.keyup, target = window } = {}) {
    if (!Object.values(keyboardEventTypes).includes(event)) {
        throw new Error(`useKeyboardShortcuts: unsupported event "${event}". Use a value from keyboardEventTypes.`);
    }

    const onKey = (nativeEvent) => {
        const handler = keyMap[nativeEvent.key];
        if (handler) {
            handler(nativeEvent);
        }
    };

    const start = () => target.addEventListener(event, onKey);
    const stop = () => target.removeEventListener(event, onKey);

    onUnmounted(stop);

    return { start, stop };
}
